export enum DateType {
    Now = 0,
    DepartAt = 1,
    ArriveBy = 2
}
